import React, { useState } from 'react';
import { LeafIcon, CheckCircleIcon } from 'lucide-react';
import { Modal } from './Modal';
export function FinalCTA() {
  const [modalContent, setModalContent] = useState<string | null>(null);
  const checkoutUrl = 'https://ewordmedia.com/cart/48415277515004:1?checkout';
  const benefits = ['Heal your family naturally', 'Support your immunity', 'Ease pain and inflammation', 'Sleep deeper', 'Feel better—using real plants, not synthetic drugs'];
  const openModal = (content: string) => {
    setModalContent(content);
  };
  const closeModal = () => {
    setModalContent(null);
  };
  const getModalContent = () => {
    switch (modalContent) {
      case 'terms':
        return {
          title: 'Terms of Service',
          content: <div className="space-y-4 text-stone-700" data-id="element-188">
              <p className="text-sm text-stone-600" data-id="element-189">
                Last updated: December 2025
              </p>

              <div data-id="element-190">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-191">
                  1. Acceptance of Terms
                </h4>
                <p data-id="element-192">
                  By accessing or using The Natural Remedy Survival Guide
                  website ("Site") or purchasing any digital products
                  ("Products") from us, you agree to be bound by these Terms of
                  Service. If you do not agree, please discontinue use
                  immediately.
                </p>
              </div>

              <div data-id="element-193">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-194">
                  2. Digital Product License
                </h4>
                <p data-id="element-195">
                  We grant you a limited, personal, non-exclusive,
                  non-transferable license to download and use the digital
                  materials for your own private, non-commercial use. You may
                  not reproduce, distribute, resell, or share the content.
                </p>
              </div>

              <div data-id="element-196">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-197">
                  3. No Medical Advice
                </h4>
                <p data-id="element-198">
                  All content provided on this Site and in our Products is for
                  educational and informational purposes only and is not medical
                  advice. Consult with a qualified healthcare professional
                  before making any changes to diet, supplements, herbs, or
                  lifestyle.
                </p>
              </div>

              <div data-id="element-199">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-200">
                  4. Disclaimer of Warranties
                </h4>
                <p data-id="element-201">
                  All materials are provided "as is" with no warranties,
                  expressed or implied. We do not guarantee results, outcomes,
                  or health improvements.
                </p>
              </div>

              <div data-id="element-202">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-203">
                  5. Limitation of Liability
                </h4>
                <p className="mb-2" data-id="element-204">
                  In no event shall The Natural Remedy Survival Guide, its
                  owners, or suppliers be liable for any damages, injuries, or
                  losses arising from the use or misuse of our content,
                  including but not limited to:
                </p>
                <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-205">
                  <li data-id="element-206">health outcomes</li>
                  <li data-id="element-207">business losses</li>
                  <li data-id="element-208">data loss</li>
                  <li data-id="element-209">inability to access digital products</li>
                </ul>
                <p className="mt-2" data-id="element-210">
                  Your use of the Site and Products is at your own risk.
                </p>
              </div>

              <div data-id="element-211">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-212">
                  6. Refunds
                </h4>
                <p data-id="element-213">
                  We offer a 30-day money-back guarantee on the main digital
                  product. Refunds will only be issued to the original payment
                  method.
                </p>
              </div>

              <div data-id="element-214">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-215">
                  7. User Conduct
                </h4>
                <p className="mb-2" data-id="element-216">You agree not to:</p>
                <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-217">
                  <li data-id="element-218">share or resell digital files</li>
                  <li data-id="element-219">attempt unauthorized access to our systems</li>
                  <li data-id="element-220">violate copyright or intellectual property laws</li>
                </ul>
              </div>

              <div data-id="element-221">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-222">
                  8. Modifications to Terms
                </h4>
                <p data-id="element-223">
                  We may update these Terms at any time. Continued use of the
                  Site constitutes acceptance of any changes.
                </p>
              </div>

              <div data-id="element-224">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-225">
                  9. Governing Law
                </h4>
                <p data-id="element-226">
                  These Terms are governed by the laws of the United States and
                  the state associated with our business registration, without
                  regard to conflict of law rules.
                </p>
              </div>
            </div>
        };
      case 'privacy':
        return {
          title: 'Privacy Policy',
          content: <div className="space-y-4 text-stone-700" data-id="element-227">
              <p className="text-sm text-stone-600" data-id="element-228">
                Last updated: December 2025
              </p>
              <p data-id="element-229">
                We respect your privacy. This Privacy Policy explains how we
                collect, use, and protect your information.
              </p>

              <div data-id="element-230">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-231">
                  1. Information We Collect
                </h4>
                <p className="mb-2" data-id="element-232">
                  We collect the following information when you use our Site:
                </p>
                <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-233">
                  <li data-id="element-234">Name</li>
                  <li data-id="element-235">Email address</li>
                  <li data-id="element-236">Payment information</li>
                  <li data-id="element-237">Order details</li>
                  <li data-id="element-238">IP address</li>
                  <li data-id="element-239">Basic browsing behavior (via cookies)</li>
                </ul>
                <p className="mt-2 font-medium" data-id="element-240">
                  We do NOT collect medical or sensitive personal data.
                </p>
              </div>

              <div data-id="element-241">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-242">
                  2. How We Use Your Information
                </h4>
                <p className="mb-2" data-id="element-243">We use your information to:</p>
                <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-244">
                  <li data-id="element-245">Process your digital product order</li>
                  <li data-id="element-246">Send purchase confirmations</li>
                  <li data-id="element-247">Deliver product files</li>
                  <li data-id="element-248">Provide customer support</li>
                  <li data-id="element-249">Improve the Site and product experience</li>
                  <li data-id="element-250">
                    Send optional follow-up health tips or product updates (you
                    may unsubscribe anytime)
                  </li>
                </ul>
              </div>

              <div data-id="element-251">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-252">
                  3. Information Sharing
                </h4>
                <p className="mb-2" data-id="element-253">
                  We do NOT sell or trade your personal information. We only
                  share data with:
                </p>
                <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-254">
                  <li data-id="element-255">Payment processors</li>
                  <li data-id="element-256">Email delivery providers</li>
                  <li data-id="element-257">
                    Essential service partners required to fulfill your order
                  </li>
                </ul>
                <p className="mt-2" data-id="element-258">
                  All partners adhere to strict security standards.
                </p>
              </div>

              <div data-id="element-259">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-260">
                  4. Cookies & Tracking Technologies
                </h4>
                <p className="mb-2" data-id="element-261">We use cookies to:</p>
                <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-262">
                  <li data-id="element-263">personalize your experience</li>
                  <li data-id="element-264">track site performance</li>
                  <li data-id="element-265">improve conversions</li>
                  <li data-id="element-266">run ads (Meta/Google compliance)</li>
                </ul>
                <p className="mt-2" data-id="element-267">
                  You may disable cookies in your browser settings.
                </p>
              </div>

              <div data-id="element-268">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-269">
                  5. Data Security
                </h4>
                <p data-id="element-270">
                  We use industry-standard SSL encryption and secure payment
                  gateways to protect your data.
                </p>
              </div>

              <div data-id="element-271">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-272">
                  6. Your Rights
                </h4>
                <p className="mb-2" data-id="element-273">You may request:</p>
                <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-274">
                  <li data-id="element-275">a copy of your data</li>
                  <li data-id="element-276">correction of your data</li>
                  <li data-id="element-277">deletion of your data</li>
                  <li data-id="element-278">to opt out of marketing emails</li>
                </ul>
              </div>

              <div data-id="element-279">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-280">
                  7. Third-Party Links
                </h4>
                <p data-id="element-281">
                  Our Site may contain external links. We are not responsible
                  for their privacy practices.
                </p>
              </div>

              <div data-id="element-282">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-283">
                  8. Contact
                </h4>
                <p data-id="element-284">
                  For privacy concerns, email:{' '}
                  <a href="mailto:support@thenaturalremedyguide.com" className="text-emerald-700 hover:text-emerald-800 underline" data-id="element-285">
                    support@thenaturalremedyguide.com
                  </a>
                </p>
              </div>
            </div>
        };
      case 'refund':
        return {
          title: 'Refund Policy',
          content: <div className="space-y-4 text-stone-700" data-id="element-286">
              <p className="text-sm text-stone-600" data-id="element-287">
                Last updated: December 2025
              </p>
              <p data-id="element-288">
                At The Natural Remedy Survival Guide, we want all customers to
                feel confident when purchasing our digital products.
              </p>

              <div data-id="element-289">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-290">
                  Eligibility for Refunds
                </h4>
                <p className="mb-2" data-id="element-291">
                  We offer a 30-day money-back guarantee on the main ebook ("The
                  Natural Remedy Survival Guide").
                </p>
                <p className="mb-2" data-id="element-292">To qualify:</p>
                <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-293">
                  <li data-id="element-294">Request must be made within 30 days of purchase</li>
                  <li data-id="element-295">The purchase must be the main product</li>
                  <li data-id="element-296">
                    Upsells, downsells, and bonus digital items are
                    non-refundable (these are delivered instantly and cannot be
                    returned)
                  </li>
                </ul>
              </div>

              <div data-id="element-297">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-298">
                  How to Request a Refund
                </h4>
                <p className="mb-2" data-id="element-299">
                  Email us at: 👉{' '}
                  <a href="mailto:support@thenaturalremedyguide.com" className="text-emerald-700 hover:text-emerald-800 underline font-medium" data-id="element-300">
                    support@thenaturalremedyguide.com
                  </a>
                </p>
                <p className="mb-2" data-id="element-301">Include your:</p>
                <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-302">
                  <li data-id="element-303">Full name</li>
                  <li data-id="element-304">Order email</li>
                  <li data-id="element-305">Order number</li>
                </ul>
                <p className="mt-2" data-id="element-306">
                  Refunds are issued back to the original payment method.
                </p>
              </div>

              <div data-id="element-307">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-308">
                  Non-Refundable Items
                </h4>
                <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-309">
                  <li data-id="element-310">Upsells (e.g., The 14-Day Herbal Detox Meal Plan)</li>
                  <li data-id="element-311">Downsells (Mini Detox Booster)</li>
                  <li data-id="element-312">Bonus ebooks</li>
                  <li data-id="element-313">Bundled files</li>
                  <li data-id="element-314">Instant digital downloads outside the main product</li>
                </ul>
              </div>

              <div data-id="element-315">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-316">
                  Abuse of Refund Policy
                </h4>
                <p data-id="element-317">
                  We reserve the right to refuse refunds to customers who abuse
                  the system (e.g., repeated refunds or chargebacks).
                </p>
              </div>
            </div>
        };
      case 'shipping':
        return {
          title: 'Shipping Policy',
          content: <div className="space-y-4 text-stone-700" data-id="element-318">
              <p className="text-sm text-stone-600" data-id="element-319">
                Last updated: December 2025
              </p>
              <p className="font-medium text-stone-900" data-id="element-320">
                All products sold on this Site are 100% digital and delivered
                instantly.
              </p>

              <div data-id="element-321">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-322">
                  1. Delivery Method
                </h4>
                <p className="mb-2" data-id="element-323">
                  Immediately after purchase, you will receive:
                </p>
                <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-324">
                  <li data-id="element-325">A confirmation email</li>
                  <li data-id="element-326">Download links to your digital files</li>
                </ul>
                <p className="mt-2" data-id="element-327">
                  Files are delivered in PDF or digital card format.
                </p>
              </div>

              <div data-id="element-328">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-329">
                  2. No Physical Shipping
                </h4>
                <p className="mb-2" data-id="element-330">
                  We do NOT ship physical products. There are:
                </p>
                <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-331">
                  <li data-id="element-332">no shipping fees</li>
                  <li data-id="element-333">no delivery delays</li>
                  <li data-id="element-334">no physical mail</li>
                </ul>
              </div>

              <div data-id="element-335">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-336">
                  3. Delivery Problems
                </h4>
                <p className="mb-2" data-id="element-337">
                  If you do not receive your download links within 5 minutes,
                  please:
                </p>
                <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-338">
                  <li data-id="element-339">check your spam folder</li>
                  <li data-id="element-340">verify your email was typed correctly</li>
                  <li data-id="element-341">
                    contact support at{' '}
                    <a href="mailto:support@thenaturalremedyguide.com" className="text-emerald-700 hover:text-emerald-800 underline" data-id="element-342">
                      support@thenaturalremedyguide.com
                    </a>
                  </li>
                </ul>
                <p className="mt-2 font-medium" data-id="element-343">
                  We will resend your files immediately.
                </p>
              </div>
            </div>
        };
      case 'disclaimer':
        return {
          title: 'Medical Disclaimer',
          content: <div className="space-y-4 text-stone-700" data-id="element-344">
              <p className="text-sm text-stone-600" data-id="element-345">
                Last updated: December 2025
              </p>

              <div data-id="element-346">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-347">
                  1. Not Medical Advice
                </h4>
                <p className="mb-2" data-id="element-348">
                  The information, digital products, and recommendations
                  provided on this Site are for educational and informational
                  purposes only and are not intended as:
                </p>
                <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-349">
                  <li data-id="element-350">medical advice</li>
                  <li data-id="element-351">diagnosis</li>
                  <li data-id="element-352">treatment</li>
                  <li data-id="element-353">cure</li>
                  <li data-id="element-354">or prevention of any disease</li>
                </ul>
                <p className="mt-2 font-medium" data-id="element-355">
                  Always consult a licensed healthcare professional before
                  starting any new diet, supplement, detox, or remedy.
                </p>
              </div>

              <div data-id="element-356">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-357">
                  2. No Guarantees
                </h4>
                <p className="mb-2" data-id="element-358">
                  Results vary from person to person and depend on many factors
                  including lifestyle, health conditions, and consistency.
                </p>
                <p className="font-medium" data-id="element-359">
                  We make no guarantees regarding specific outcomes,
                  improvements, or changes.
                </p>
              </div>

              <div data-id="element-360">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-361">
                  3. Not Evaluated by the FDA
                </h4>
                <p data-id="element-362">
                  Statements on this Site and in our digital products have not
                  been evaluated by the Food and Drug Administration.
                </p>
              </div>

              <div data-id="element-363">
                <h4 className="font-semibold text-stone-900 mb-2" data-id="element-364">
                  4. Use at Your Own Risk
                </h4>
                <p className="mb-2" data-id="element-365">By using this Site, you agree that:</p>
                <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-366">
                  <li data-id="element-367">
                    you assume full responsibility for your health decisions
                  </li>
                  <li data-id="element-368">you use the materials at your own risk</li>
                  <li data-id="element-369">you will consult a professional if you have concerns</li>
                </ul>
              </div>
            </div>
        };
      case 'contact':
        return {
          title: 'Contact Us',
          content: <div className="space-y-4 text-stone-700" data-id="element-370">
              <p data-id="element-371">
                We're here to help! If you have questions about your order,
                accessing your digital products, or general support, feel free
                to reach out.
              </p>

              <div className="bg-emerald-50 p-6 rounded-lg space-y-4" data-id="element-372">
                <div data-id="element-373">
                  <h4 className="font-semibold text-stone-900 mb-2 flex items-center gap-2" data-id="element-374">
                    <span data-id="element-375">📧</span>
                    <span data-id="element-376">Email Support</span>
                  </h4>
                  <p className="mb-1" data-id="element-377">
                    <a href="mailto:support@thenaturalremedyguide.com" className="text-emerald-700 hover:text-emerald-800 underline font-medium" data-id="element-378">
                      support@thenaturalremedyguide.com
                    </a>
                  </p>
                  <p className="text-sm text-stone-600" data-id="element-379">
                    (Please include your order number for faster assistance.)
                  </p>
                </div>

                <div data-id="element-380">
                  <h4 className="font-semibold text-stone-900 mb-2 flex items-center gap-2" data-id="element-381">
                    <span data-id="element-382">⏱</span>
                    <span data-id="element-383">Response Time</span>
                  </h4>
                  <p data-id="element-384">We typically reply within 24–48 hours.</p>
                </div>

                <div data-id="element-385">
                  <h4 className="font-semibold text-stone-900 mb-2 flex items-center gap-2" data-id="element-386">
                    <span data-id="element-387">🕒</span>
                    <span data-id="element-388">Support Hours</span>
                  </h4>
                  <p data-id="element-389">
                    Monday–Friday
                    <br data-id="element-390" />
                    9:00 AM – 5:00 PM EST
                  </p>
                </div>
              </div>

              <div data-id="element-391">
                <h4 className="font-semibold text-stone-900 mb-2 flex items-center gap-2" data-id="element-392">
                  <span data-id="element-393">📦</span>
                  <span data-id="element-394">Order Issues</span>
                </h4>
                <p className="mb-2" data-id="element-395">
                  If you did not receive your download links within a few
                  minutes of purchase, please:
                </p>
                <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-396">
                  <li data-id="element-397">Check your spam or promotions folder</li>
                  <li data-id="element-398">
                    Verify that your email address was entered correctly at
                    checkout
                  </li>
                  <li data-id="element-399">Contact us and we'll resend your files right away</li>
                </ul>
              </div>

              <p className="text-center font-medium text-stone-900 pt-2" data-id="element-400">
                We're committed to making sure you get your digital products
                quickly and without issues.
              </p>
            </div>
        };
      default:
        return {
          title: '',
          content: null
        };
    }
  };
  const modal = getModalContent();
  return <section className="w-full bg-gradient-to-b from-emerald-700 to-emerald-900 text-white py-16 md:py-24" data-id="element-401">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-402">
        <LeafIcon className="w-16 h-16 mx-auto mb-6 text-emerald-200" data-id="element-403" />
        <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-404">
          Take Back Control of Your Wellness
        </h2>
        <p className="text-xl mb-8" data-id="element-405">
          Kick the dependency on pharmacies, pills, and chemicals.
        </p>
        <div className="bg-white/10 backdrop-blur rounded-xl p-8 mb-8" data-id="element-406">
          <div className="space-y-3 text-left max-w-2xl mx-auto" data-id="element-407">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-3" data-id="element-408">
                <CheckCircleIcon className="w-6 h-6 text-emerald-300 flex-shrink-0" data-id="element-409" />
                <p className="text-lg" data-id="element-410">{benefit}</p>
              </div>)}
          </div>
        </div>
        <div className="space-y-3 mb-8" data-id="element-411">
          <a href={checkoutUrl} data-cta="final" onClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'AddToCart');
          }
        }} className="inline-block bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 focus:from-orange-600 focus:to-orange-700 focus:outline-none focus:ring-4 focus:ring-orange-300 text-white px-12 py-6 rounded-2xl text-xl font-bold transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-[1.02] focus:shadow-2xl focus:scale-[1.02] transform" data-id="element-412">
            <span className="flex items-center justify-center gap-3" data-id="element-413">
              <span data-id="element-414">Only $17 Today</span>
              <span className="text-2xl" data-id="element-415">›</span>
            </span>
          </a>
          <p className="text-center text-emerald-100" data-id="element-416">
            <span className="font-semibold" data-id="element-417">Total value: </span>
            <span className="line-through" data-id="element-418">$51</span>
            <span className="text-emerald-200 font-semibold" data-id="element-419">
              {' '}
              • You save $34
            </span>
          </p>
        </div>
        <p className="text-emerald-100 text-sm mb-6 italic mt-8" data-id="element-420">
          *You will receive your ebook in PDF format immediately after purchase.
        </p>
        <div className="pt-8 border-t border-emerald-600" data-id="element-421">
          <div className="flex flex-wrap justify-center gap-6 mb-4" data-id="element-422">
            <button onClick={() => openModal('terms')} className="text-emerald-200 hover:text-white focus:text-white focus:outline-none focus:underline transition-all duration-200 underline hover:scale-105 focus:scale-105 transform inline-block font-medium" data-id="element-423">
              Terms of Service
            </button>
            <button onClick={() => openModal('privacy')} className="text-emerald-200 hover:text-white focus:text-white focus:outline-none focus:underline transition-all duration-200 underline hover:scale-105 focus:scale-105 transform inline-block font-medium" data-id="element-424">
              Privacy Policy
            </button>
            <button onClick={() => openModal('refund')} className="text-emerald-200 hover:text-white focus:text-white focus:outline-none focus:underline transition-all duration-200 underline hover:scale-105 focus:scale-105 transform inline-block font-medium" data-id="element-425">
              Refund Policy
            </button>
            <button onClick={() => openModal('shipping')} className="text-emerald-200 hover:text-white focus:text-white focus:outline-none focus:underline transition-all duration-200 underline hover:scale-105 focus:scale-105 transform inline-block font-medium" data-id="element-426">
              Shipping Policy
            </button>
            <button onClick={() => openModal('disclaimer')} className="text-emerald-200 hover:text-white focus:text-white focus:outline-none focus:underline transition-all duration-200 underline hover:scale-105 focus:scale-105 transform inline-block font-medium" data-id="element-427">
              Medical Disclaimer
            </button>
            <button onClick={() => openModal('contact')} className="text-emerald-200 hover:text-white focus:text-white focus:outline-none focus:underline transition-all duration-200 underline hover:scale-105 focus:scale-105 transform inline-block font-medium" data-id="element-428">
              Contact
            </button>
          </div>
          <p className="text-emerald-200 text-sm" data-id="element-429">
            © 2024 Natural Remedy Survival Guide. All rights reserved.
          </p>
        </div>
      </div>
      <Modal isOpen={modalContent !== null} onClose={closeModal} title={modal.title} data-id="element-430">
        {modal.content}
      </Modal>
    </section>;
}